import * as _ from "lodash";

export default function Throttle(timeout: number, leading?: boolean, trailing?: boolean): MethodDecorator {
    return function (target: object, key: string | symbol, descriptor: PropertyDescriptor) {
        if (descriptor === undefined) {
            descriptor = Object.getOwnPropertyDescriptor(target, key);
        }
        const originalMethod = descriptor.value;

        const throttled = _.throttle(originalMethod, timeout, { leading, trailing });
        descriptor.value = throttled;
    }
}